// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '../static/assets/styles/css/bootstrap.min.css'
import '../static/assets/plugins/materialdesignicons/css/materialdesignicons.css'
import '../static/assets/styles/scss/template.scss'
import Vue from 'vue'
import App from './App'
import router from './router'
import uploader from 'vue-simple-uploader'
import store from './store'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import Vuebar from 'vuebar'
import Toasted from 'vue-toasted'
import vSelect from 'vue-select'
import lodash from 'lodash'
import VueLodash from 'vue-lodash/dist/vue-lodash.min'
import Vddl from 'vddl'
import {
  server
} from '@/components/mfs.server.config'
import CheckboxRadio from 'vue-checkbox-radio'
import MKCLAPI from '../static/mkclLogin.js'
import VeeValidate from 'vee-validate'
import vuexI18n from 'vuex-i18n'
import VueQrcodeReader from 'vue-qrcode-reader'
import Vue2Filters from 'vue2-filters'
import translationsEn from '../static/localization/en.json'
import translationsMr from '../static/localization/mr.json'
import translationsHi from '../static/localization/hi.json'
initConfig()
Vue.use(vuexI18n.plugin, store)
Vue.i18n.add('hi', translationsHi)
Vue.i18n.add('en', translationsEn)
Vue.i18n.add('mr', translationsMr)

// set the start locale to use
Vue.i18n.set('en')
Vue.use(Vddl)
Vue.use(VueLodash, lodash)
Vue.use(BootstrapVue)
Vue.use(Vuebar)
Vue.use(uploader)
Vue.use(VeeValidate)
Vue.component('v-select', vSelect)
Vue.use(CheckboxRadio)
Vue.use(VueQrcodeReader)
Vue.use(Vue2Filters)
Vue.use(Toasted, {
  duration: 4000,
  theme: 'bubble'
})
Vue.config.productionTip = false
// window.mkclApi = mkclApi
window.MKCLAPI = MKCLAPI

const ENVIRONMENT = 'PROD' // eg. PROD,DEV
const CNDHEADER = 'TNOU' // eh. ERA,TNOU

if (ENVIRONMENT === 'PROD') {
  window.MKCLAPI.init({
    clientId: 'MFS_APPLICANT',
    mkclLoginServerURL: window.MKCL_HOST + '/ssoserver',
    mkclLoginClientURL: window.MKCL_HOST + '/sso/#/login',
    MFS_REGISTRATION_URL: window.MKCL_HOST + '/registration/'
  })
  Vue.mixin({
    data: function () {
      return {
        // Application Constants
        MFS_APPLICANT_ID: 'MFS_APPLICANT',
        MFS_CLIENT_ID: 'MFS',
        MFS_INDUSTRY_PARTNER_ID: 'MFS_INDUSTRY_PARTNER',
        MFS_ASC_ID: 'MFS_ASC',
        MFS_ADMIN_ID: 'MFS_ADMIN',
        CDN_LOAD_BALANCER_URL: window.MKCL_HOST + '/lb/',
        CDN_URL: window.MKCL_HOST + '/cdn/',
        /* CDN_BUSINESS_HEADER: 'ERA', */
        CDN_BUSINESS_HEADER: CNDHEADER,
        CDN_CLIENT_HEADER: 'MFSFramework',
        // Application URL
        /* CDN_LOAD_BALANCER_URL: 'http://applymfs.mkcl.org/lb/',
        CDN_URL: 'http://applymfs.mkcl.org/cdn/', */
       /*  CDN_LOAD_BALANCER_URL: 'http://10.2.10.42:9091/',
        CDN_URL: 'http://10.2.10.42:9090/', */
        MFS_URL: window.MKCL_HOST + '/mfs/',
        MFS_REGISTRATION_URL: window.MKCL_HOST + '/registration/#/',
        TOASTR_TIME: 4000
      }
    }
  })
} else {
  window.MKCLAPI.init({
    clientId: 'MFS_APPLICANT',
    mkclLoginServerURL: 'http://localhost:5002',
    mkclLoginClientURL: 'http://localhost:8080/#/login',
    MFS_REGISTRATION_URL: 'http://localhost:8088/#/'
  })
  Vue.mixin({
    data: function () {
      return {
        // Application Constants
        MFS_APPLICANT_ID: 'MFS_APPLICANT',
        MFS_CLIENT_ID: 'MFS',
        MFS_INDUSTRY_PARTNER_ID: 'MFS_INDUSTRY_PARTNER',
        MFS_ASC_ID: 'MFS_ASC',
        MFS_ADMIN_ID: 'MFS_ADMIN',
        // Application URL
        CDN_LOAD_BALANCER_URL: 'http://10.2.10.42:9091/',
        CDN_URL: 'http://10.2.10.42:9090/',
        CDN_BUSINESS_HEADER: 'ERA',
        CDN_CLIENT_HEADER: 'MFSFramework',
        MFS_URL: '',
        MFS_REGISTRATION_URL: 'http://localhost:8088/#/',
        TOASTR_TIME: 4000
      }
    }
  })
}

window.lcmsserver = server.address
// axios.interceptors.request.use(function (config) {
//   config.headers.post['Content-Type'] = 'application/json'

//   return config
// })
// set baseUrl from app : local
axios.defaults.baseURL = '/mfsserver/'
// production
// axios.defaults.baseURL = 'http://localhost:3030/'

axios.interceptors.request.use(function (config) {
  store.commit('STORE_LOADING', true)
  var clientId = MKCLAPI.config.clientId
  if (clientId != null) {
    config.headers.ClientId = clientId
  }
  if ((config.baseURL.indexOf('mfsserver') !== -1 || config.baseURL.indexOf('ssoserver') !== -1) && (config.baseURL + config.url).indexOf('/o/') === -1) {
    let token = window.MKCLAPI.getToken(clientId)
    if (token) {
      config.headers.common['authorization'] = token
      config.headers.post['Content-Type'] = 'application/json'
    } else {
      store.commit('STORE_CLEAR_ALL')
      sessionStorage.removeItem('authorization')
      window.localStorage.clear()
      window.location.href = MKCLAPI.config.MFS_REGISTRATION_URL
      return
    }
  }
  return config
}, function (error) {
  store.commit('STORE_LOADING', false)
  return Promise.reject(error)
})

/* axios.interceptors.response.use((response) => {
  return response
}, function (error) {
  // Do something with response error
  if (error.response.status === 401) {
    Vue.toasted.error('Your Session is Expired....Please Login Again!')
    window.MKCLAPI.deleteAllCookies()
    // router.replace('/login')
    window.location.href = MKCLAPI.config.MFS_REGISTRATION_URL
  }
  // Do something with response error
  if (error.response.status === 400) {
    window.location.href = MKCLAPI.config.MFS_REGISTRATION_URL
  }
  return Promise.reject(error)
}) */

var showToasterFlag = true
axios.interceptors.response.use((response) => {
  store.commit('STORE_LOADING', false)
  if (response.status === 208 && showToasterFlag) {
    showToasterFlag = false
    alert('Found another active session')
    sessionStorage.removeItem('authorization')
    window.localStorage.clear()
    window.location.href = MKCLAPI.config.MFS_REGISTRATION_URL
  }
  return response
}, function (error) {
  store.commit('STORE_LOADING', false)
  if (error.response.status === 504 && showToasterFlag) {
    showToasterFlag = false
    store.commit('STORE_CLEAR_ALL')
    window.MKCLAPI.deleteAllCookies()
    sessionStorage.removeItem('authorization')
    window.localStorage.clear()
    alert('It seems your server or internet connection is down.')
    window.location.href = MKCLAPI.config.MFS_REGISTRATION_URL
    return false
  }
  // Do something with response error
  if ((error.response.status === 400 || error.response.status === 401) && (showToasterFlag)) {
    showToasterFlag = false
    alert('Your Session is Expired....Please Login Again!!!')
    store.commit('STORE_CLEAR_ALL')
    window.MKCLAPI.deleteAllCookies()
    sessionStorage.removeItem('authorization')
    window.localStorage.clear()
    window.location.href = MKCLAPI.config.MFS_REGISTRATION_URL
  }
  return Promise.reject(error)
})

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})

window.app = vm

router.beforeEach(function (to, from, next) {
  if (to.matched.some(record => record.meta.requireAuth)) {
    window.MKCLAPI.isSessionPresent().then(function () {
      next()
    }).catch(function () {
      alert('Your Session is Expired....Please Login Again!!')
      store.commit('STORE_CLEAR_ALL')
      window.MKCLAPI.deleteAllCookies()
      sessionStorage.removeItem('authorization')
      window.localStorage.clear()
      window.location.href = MKCLAPI.config.MFS_REGISTRATION_URL
    })
  } else {
    next()
  }
})

function initConfig () {
  var url = window.location.href
  var arr = url.split('/')
  var result = arr[0] + '//' + arr[2]
  window.MKCL_HOST = result
}



// WEBPACK FOOTER //
// ./src/main.js